import React, { useEffect, useState } from "react";
import FetchCharts from 'utils/fetch/FetchCharts'
import _ from 'lodash'
import LoadingComponent from 'components/atoms/Loading'
import Text from "theme/Text";
import { textStyles } from 'styles/text'
import i18n from 'utils/i18n'
import ThemedBlock from 'components/atoms/ThemedBlock'
import WebView from 'components/atoms/WebView'
import HelperString from 'utils/helper-string'
import GraphContainer from 'components/atoms/GraphContainer'
import { GraphVariables } from 'components/management/molecules/graphs'

const GraphBookingPresenceChart = ({ dateRange, building, floor, room, team, employee } = {} ) => {
	
	const [ chart, setChart ] = useState( null )
	const [ data, setData ] = useState( null )
	
	useEffect(() => {
		FetchCharts.fetchBookingsPresent({
			variables: GraphVariables({
				dateRange, building, floor, room, team, employee
			}),
			callbackSuccess: ( chart ) => {
				setChart( chart )
				setData( _.isEmpty( chart.data ) ? false : JSON.parse( chart.data ) )
			}
		} );
	}, dateRange )
	
	if( chart === null ) {
		return (
			<LoadingComponent />
		)
	}
	
	let content = (
		<ThemedBlock transparent mediumPadding>
			<Text style={ textStyles.textCenter }>
				{ i18n.t( 'management:generic.no_results' ) }
			</Text>
		</ThemedBlock>
	)
	
	if( !_.isEmpty( chart ) ) {
		content = (
			<WebView
				key={ HelperString.hash( 'webview', dateRange ) }
				html={ chart.html }
			/>
		)
	}
	
	return (
		<GraphContainer
			chart={ chart }
			title={ chart.name }>
			
			{ content }
		</GraphContainer>
	)
}

export default GraphBookingPresenceChart
